/* Stick Snak purchase controls — pack radios, subscribe toggle, qty stepper.
   Works inside Horizon's <product-form-component>; this script only keeps the
   hidden variant id / selling_plan / displayed prices in sync. */
(function () {
  function formatMoney(cents, format) {
    const value = cents / 100;
    const amount = (key) => {
      switch (key) {
        case 'amount_no_decimals':
          return Math.round(value).toLocaleString('en-US');
        case 'amount_with_comma_separator':
          return value.toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        case 'amount_no_decimals_with_comma_separator':
          return Math.round(value).toLocaleString('nl-NL');
        default:
          return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    };
    return (format || '€{{amount_with_comma_separator}}').replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k) => amount(k));
  }

  function initBuy(root) {
    if (root.dataset.ssInit) return;
    root.dataset.ssInit = '1';

    const moneyFormat = root.dataset.moneyFormat;
    const variantInput = root.querySelector('input[name="id"]');
    const packs = Array.from(root.querySelectorAll('input[name="ss-pack"]'));
    const planInput = root.querySelector('[data-ss-selling-plan-input]');
    const modeBtns = Array.from(root.querySelectorAll('[data-ss-mode]'));
    const qtyInput = root.querySelector('.ss-buy__qty-input');
    const totalEl = root.querySelector('[data-ss-total]');

    let subscribing = false;

    const requestedPack = new URLSearchParams(window.location.search).get('pack');
    if (requestedPack) {
      const requestedInput = packs.find((input) => input.dataset.units === requestedPack && !input.disabled);
      if (requestedInput) requestedInput.checked = true;
    }

    const money = (cents) => formatMoney(cents, moneyFormat);

    function selectedPack() {
      return packs.find((p) => p.checked) || packs[0];
    }

    function update() {
      const pack = selectedPack();
      if (!pack) return;
      if (variantInput) variantInput.value = pack.value;

      packs.forEach((input) => {
        const label = input.closest('.ss-buy__pack');
        if (label) label.classList.toggle('is-selected', input.checked);
        const price = Number(input.dataset.price);
        const subPrice = Number(input.dataset.subPrice || input.dataset.price);
        const now = label && label.querySelector('[data-ss-pack-price]');
        const was = label && label.querySelector('[data-ss-pack-was]');
        const meta = label && label.querySelector('[data-ss-pack-meta]');
        const active = subscribing ? subPrice : price;
        if (now) now.textContent = money(active);
        if (was) was.hidden = !(subscribing && subPrice < price);
        if (meta) {
          const units = Math.max(1, Number(input.dataset.units) || 1);
          const unitPrice = Math.round(active / units);
          const unitsLabel = units === 1 ? meta.dataset.oneUnitLabel : meta.dataset.unitsLabel;
          meta.textContent = `${unitsLabel} · ${money(unitPrice)}${meta.dataset.unitSuffix}`;
        }
      });

      if (planInput) planInput.value = subscribing ? planInput.dataset.planId : '';

      const qty = Math.max(1, Number(qtyInput && qtyInput.value) || 1);
      const unit = subscribing ? Number(pack.dataset.subPrice || pack.dataset.price) : Number(pack.dataset.price);
      if (totalEl) totalEl.textContent = money(unit * qty);
    }

    packs.forEach((p) => p.addEventListener('change', update));

    modeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        subscribing = btn.dataset.ssMode === 'subscribe';
        modeBtns.forEach((b) => {
          const on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        update();
      });
    });

    root.querySelectorAll('[data-ss-qty]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!qtyInput) return;
        const next = (Number(qtyInput.value) || 1) + Number(btn.dataset.ssQty);
        qtyInput.value = Math.min(20, Math.max(1, next));
        update();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', update);

    update();
  }

  function initAll() {
    document.querySelectorAll('product-form-component.ss-buy').forEach(initBuy);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
